import type { MedicationStatement } from "@medplum/fhirtypes";
import { MEDICATION_STATEMENT_COLLECTION_NAME } from "../../fhir";
import { createSubscriptionHook } from "./create-subscription-hook";

export const useMedicationStatementSubscription = createSubscriptionHook<MedicationStatement>(
  "MedicationStatement",
  MEDICATION_STATEMENT_COLLECTION_NAME,
);
